import React from 'react';

function App() {
  return (
    <div style={{ width: "100vw", height: "100vh", overflow: "hidden" }}>
      <iframe
        src="https://uniform.scholarclothings.in/app/scholaradmin-appsmith/login-page-68762e6bed6fe245e5fa8085?branch=production&embed=true" 
        width="98%"
        height="98%"
        style={{ border: "none" }}
        allowFullScreen
      />
    </div>
  );
}

export default App;
